/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { Backdrop, CircularProgress, Grid, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useObserver } from "mobx-react-lite";
import {
  useTrackMetric,
  useAppInsightsContext,
} from "@microsoft/applicationinsights-react-js";
import cancel from "../../assets/cancel.png";
import ok from "../../assets/ok.png";
import { useGlobalStore } from "../../state/GlobalStore";
import { IDeleteMaterial } from "../../state/StoreTypes";
import { apiService } from "../../services/ApiService";
import { helperMethods } from "../../hooks/helper";
import { AppInsightsConstants, ConstantVariables } from "../../Constants";
import { AppInsightMethods } from "../../AppInsightMethods";

interface IDeleteMaterialProps {
  callBackGetMaterialList: () => void;
  popup: boolean;
  closeCallback: () => void;
}

export default function DeleteMaterial(props: IDeleteMaterialProps) {
  const pageName = "DeleteMaterial";
  const appInsights = useAppInsightsContext();
  const globalStore = useGlobalStore();
  const helper = helperMethods();
  const [showSpinner, setShowSpinner] = React.useState(false);
  const [alertMeassage, setalertMeassage] = React.useState(false);
  const trackComponent = useTrackMetric(appInsights, pageName);

  useEffect(() => {
    trackComponent();
  }, []);

  const handleClose = () => {
    try {
      if (!props.popup) {
        globalStore.setOpenedModal("none");
        globalStore.setActionMenuSelectedMaterial(null);
        globalStore.setSelectedMaterialName("");
        setalertMeassage(false);
        AppInsightMethods.trackAppInsightsEvent(
          pageName,
          AppInsightsConstants.Information,
          `Delete Material close/cancel button click event.`,
          globalStore.loginUserEmail,
          window.location.href,
          ""
        );
      }
    } catch (error) {
      AppInsightMethods.TrackAppInsightsException(
        `Error at handleClose, Component: ${pageName}, Error: ${error}`
      );
    }
  };

  const onOkbtnClick = (Id: string) => {
    try {
      const delMaterial: IDeleteMaterial = {
        Id,
      };
      setShowSpinner(true);
      AppInsightMethods.trackAppInsightsEvent(
        pageName,
        AppInsightsConstants.Information,
        `Delete Material ok button click event.`,
        globalStore.loginUserEmail,
        window.location.href,
        ""
      );
      apiService
        .deleteMaterial(delMaterial)
        .then((res: any) => {
          setShowSpinner(false);
          setalertMeassage(false);
          if (res === "success") {
            helper.setSuccessMessageEvent("Material deleted successfully!");
          }
          AppInsightMethods.trackAppInsightsEvent(
            pageName,
            AppInsightsConstants.Information,
            `Delete API call success.`,
            globalStore.loginUserEmail,
            window.location.href,
            ""
          );
          handleClose();
          props.closeCallback();
          props.callBackGetMaterialList();
        })
        .catch((error: any) => {
          AppInsightMethods.TrackAppInsightsException(
            `Error at deleteMaterial, Component: ${pageName}, Error: ${error}`
          );
          setShowSpinner(false);
          setalertMeassage(true);
        });
    } catch (error) {
      AppInsightMethods.TrackAppInsightsException(
        `Error at onOkbtnClick, Component: ${pageName}, Error: ${error}`
      );
    }
  };

  return useObserver(() => {
    return (
      <>
        <Dialog open={props.popup} onClose={handleClose}>
          <Grid className="deleteDialog">
            <DialogTitle className="titleDelete">
              <b>Delete</b>
              <IconButton
                onClick={() => {
                  handleClose();
                  props.closeCallback();
                }}
              >
                <CloseRoundedIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              <DialogContentText className="contentText">
                Are you sure you want to delete{" "}
                <span className={"textBold"}>
                  {globalStore.selectedMaterialName}
                </span>
                ?
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialogbtnStyle">
              <Button
                onClick={() => {
                  handleClose;
                  props.closeCallback();
                }}
                className="btnStyle"
              >
                <img
                  src={cancel}
                  alt="cancel"
                  className="logo pointer cursor"
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role="button"
                  tabIndex={0}
                />
              </Button>
              <Button
                style={{ paddingRight: "2rem" }}
                onClick={() =>
                  onOkbtnClick(
                    `${
                      globalStore.actionMenuSelectedMaterial
                        ? globalStore.actionMenuSelectedMaterial.id
                        : ""
                    }`
                  )
                }
              >
                <img
                  src={ok}
                  alt="ok"
                  className="logo pointer cursor"
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role="button"
                  tabIndex={0}
                />
              </Button>
            </DialogActions>
            {alertMeassage && (
              <span className={"errorMessage deleteMaterialDialog"}>
                {ConstantVariables.Common_Error_Text}
              </span>
            )}
          </Grid>
        </Dialog>
        {showSpinner && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
            open={showSpinner}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </>
    );
  });
}
